import './App.css';
import Footer from './component/Footer';

import React from 'react';
import Home from './pages'
import MagicHub from './pages/MagicHub'
import Taste from './pages/Taste'
import Navbar from './component/Navbar';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
          <Route exact path='/' exact element={<Home />} />
          <Route path='/taste' element={<Taste/>} />
          <Route path='/magichub' element={<MagicHub/>} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
